import { db, firebase } from "@/firebase/config.js";

//Actualiza el cliente pero en Listdo no en procesos
export async function FBeditarCampoCliente(jsonLlega) {
    try {
        const json = {
            clave: jsonLlega.clave,
            idDoc: jsonLlega.idDoc,
            valor: jsonLlega.valor,
        }

        const collectionPathCreaProspecto = `cf-cartera/Clientes/Listado/${jsonLlega.idDoc}`;
        const docRef = db.doc(collectionPathCreaProspecto);

        const docSnapshot = await docRef.get();

        if (docSnapshot.exists) {
            await docRef.update({
                [json.clave]: json.valor,
            });
        } else {
            await docRef.set({
                [json.clave]: json.valor,
            });
        }

        return [true, "Se ha actualizado con éxito"];
    } catch (error) {
        console.error("Error al actualizar el documento:", error);
        return [false, "Error..."];
    }
}



//Actualiza ficha de cliente en procesos
export async function FBeditarFichaClienteCampo(jsonLlega) {
    try {
        //console.log(jsonLlega);
    
        const idSeguimiento = jsonLlega.seguimientoId;
        //const partes = jsonLlega.seguimientoId.split("-");
        //const idDocumento = partes[0];//Se quita porque no es necesario dividirla

        const json = {
            etapa: jsonLlega.etapa,
            clave: jsonLlega.clave,
            //idDoc: jsonLlega.seguimientoId,
            valor: jsonLlega.nuevoDato,
        };

        //console.log(json);

        const collectionPathCreaProspecto = `cf-ventas/etapas/${json.etapa}`;
        const collectionRef = db.collection(collectionPathCreaProspecto);
        const queryRef = collectionRef.where("seguimientoId", "==", idSeguimiento);
        
        const querySnapshot = await queryRef.get();
        
        if (!querySnapshot.empty) {
          const docRef = querySnapshot.docs[0].ref;
        
          await docRef.update({
            [json.clave]: json.valor,
          });
        
          return [true, "Se ha actualizado con éxito"];
        } else {
          const newDocRef = collectionRef.doc();
        
          await newDocRef.set({
            seguimientoId: idSeguimiento,
            [json.clave]: json.valor,
          });
        
          return [true, "Se ha creado con éxito"];
        }

    } catch (error) {
        console.error("Error al actualizar el documento:", error);
        return [false, "Error..."];
    }
}
